export interface ISearchStrings {
    placeholder: string;
    button: string;
}

export const SearchStrings: {
    PTBR: ISearchStrings
} = {
    PTBR: {
        placeholder: "Digite aqui o nome da peça que procura",
        button: "Pesquisar",
    },
};